<template>
  <div class="d-flex flex-row flex-shrink-1 bd-highlight align-items-center">
    <div class="bg-white rounded-pill border-4">
      <div
        class="rounded-pill text-truncate px-3"
        :style="{
          backgroundColor: source.bgColor ?? getBg(source.color),
          border: source.brColor ?? getBr(source.color)
        }"
      >
        <i
          class="mr-2"
          :class="source.icon"
          :style="{ color: source.iconColor ?? source.color }"
        ></i>
        <b> {{ source.title | empty }} </b>
      </div>
    </div>
    <div>
      <i
        class="h-25 arrow-icon-divider border rounded-pill border-4 border-dark  px-1 fas fa-angle-right mx-2"
      ></i>
    </div>
    <div class="bg-white rounded-pill border-4">
      <div
        class="rounded-pill text-truncate px-3"
        :style="{
          backgroundColor: destination.bgColor ?? getBg(destination.color),
          border: destination.brColor ?? getBr(destination.color)
        }"
      >
        <i
          class="mr-2"
          :class="destination.icon"
          :style="{ color: destination.iconColor ?? destination.color }"
        ></i>
        <b> {{ destination.title | empty }} </b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomStatusTransaction",
  props: {
    source: {
      type: Object,
      require: false,
      default: () => ({})
    },
    destination: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  methods: {
    getBr(hex) {
      if (!hex) return;
      return `1px solid ${hex}`;
    },
    getBg(hex) {
      if (!hex) return;
      hex = hex.replace(/^#/, "");

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `rgb(${r} ${g} ${b} /25%)`;
    }
  }
};
</script>

<style scoped>
.arrow-icon-divider {
  color: #3f5b60;
}
</style>
